import React from "react";

const SpinnerAnimation = ({ style, className }) => (
  <span className={className} style={style}>
    <div className="lds-spin">
      <div><div /></div>
      <div><div /></div>
      <div><div /></div>
      <div><div /></div>
      <div><div /></div>
      <div><div /></div>
      <div><div /></div>
      <div><div /></div>
      <div><div /></div>
      <div><div /></div>
    </div>
  </span>
);

export default SpinnerAnimation;